import { api } from './api';



export const documentsTypeList = async (url = "") => {
  return await api.get(
    `/documents/type/list${url}`
  );
};
export const documentsTypeAdd = async (data) => {
  return await api.post('/documents/type/add', data);
};

export const documentsTypeUpdate = async (data) => {
  return await api.post('/documents/type/update', data);
};

export const documentsTypeStatusChange = async (id) => {
  return await api.post('/documents/type/status/change', { id });
};
export const documentsTypeDelete = async (id) => {
  return await api.post('/documents/type/delete', { id });
};

export const documentsAdd = async (data) => {
  return await api.post('/documents/add', data);
};

export const documentsList = async (url) => {
  return await api.get(`/documents/list${url}`);
};

////// old ////


export const collectionDistributionCategoriesList = async () => {
  return await api.get('/collection/distribution/categories');
};

export const collectionDistributionCategoryAdd = async (data) => {
  return await api.post('/collection/distribution/category/add', data);
};

export const collectionDistributionCategoryUpdate = async (data) => {
  return await api.post('/collection/distribution/category/update', data);
};

export const collectionDistributionCategoryDelete = async (id) => {
  return await api.post('/collection/distribution/category/delete', { id });
};

export const collectionDistributionCategoryStatusChange = async (id) => {
  return await api.post('/collection/distribution/category/status/change', { id });
};

export const collectionDistributionItemsList = async () => {
  return await api.get('/collection/distribution/items/list');
};

export const collectionDistributionItemAdd = async (data) => {
  return await api.post('/collection/distribution/item/add', data);
};

export const collectionDistributionItemUpdate = async (data) => {
  return await api.post('/collection/distribution/item/update', data);
};

export const collectionDistributionItemDelete = async (id) => {
  return await api.post('/collection/distribution/item/delete', { id });
};

export const collectionDistributionItemStatusChange = async (id) => {
  return await api.post('/collection/distribution/item/status/change', { id });
};


export const collectionDistributionItemFieldsList = async (item_id) => {
  return await api.get(`/collection/distribution/item/fields/list?item_id=${item_id}`);
};

export const collectionDistributionItemFieldAdd = async (data) => {
  return await api.post('/collection/distribution/item/field/add', data);
};

export const collectionDistributionItemFieldUpdate = async (data) => {
  return await api.post('/collection/distribution/item/field/update', data);
};

export const collectionDistributionItemFieldDelete = async (id) => {
  return await api.post('/collection/distribution/item/field/delete', { id });
};

export const collectionDistributionEntryAdd = async (data) => {
  return await api.post('/collection/distribution/item/field/add', data);
};

export const collectionList = async () => {
  return await api.get('/collection/list');
};

export const collectionAdd = async (data) => {
  return await api.post('/collection/add', data);
};

export const collectionUpdate = async (data) => {
  return await api.post('/collection/update', data);
};

export const collectionDelete = async (id) => {
  return await api.post('/collection/delete', { id });
};

export const collectionStatusChange = async (id) => {
  return await api.post('/collection/status/change', { id });
};

export const collectionDetails = async (id) => {
  return await api.get(`/collection/details?id=${id}`);
};

export const distributionList = async () => {
  return await api.get('/distribution/list');
};

export const distributionAdd = async (data) => {
  return await api.post('/distribution/add', data);
};

export const distributionUpdate = async (data) => {
  return await api.post('/distribution/update', data);
};

export const distributionDelete = async (id) => {
  return await api.post('/distribution/delete', { id });
};

export const distributionStatusChange = async (id) => {
  return await api.post('/distribution/status/change', { id });
};

export const distributionDetails = async (id) => {
  return await api.get(`/distribution/details?id=${id}`);
};